import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Edit Course")
  ])
], -1)
const _hoisted_3 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Type", -1)
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Category", -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Sector", -1)
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Unit Cost", -1)
const _hoisted_25 = { class: "row mt-3" }
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Unique Course Name", -1)
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Code")
], -1)
const _hoisted_30 = { class: "row mt-3" }
const _hoisted_31 = { class: "col-md-8" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Name")
], -1)
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Short Name")
], -1)
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Target Batch")
], -1)
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Batch Size")
], -1)
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Total Target Trainee")
], -1)
const _hoisted_42 = { class: "row mt-3" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Min Age")
], -1)
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Max Age")
], -1)
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Grace(M)", -1)
const _hoisted_49 = { class: "row mt-3" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Objective")
], -1)
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Entry Qualification")
], -1)
const _hoisted_54 = { class: "card mb-5 mb-xl-10" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_term",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Term")
  ])
], -1)
const _hoisted_56 = {
  id: "course_term",
  class: "collapse show"
}
const _hoisted_57 = { class: "collapse show" }
const _hoisted_58 = { class: "card-body border-top p-5" }
const _hoisted_59 = { class: "col-md-1" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_61 = { class: "col-md-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Month", -1)
const _hoisted_63 = { class: "col-md-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Day", -1)
const _hoisted_65 = { class: "col-md-1" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session", -1)
const _hoisted_67 = { class: "col-md-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Hour", -1)
const _hoisted_69 = { class: "col-md-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Class Type", -1)
const _hoisted_71 = { class: "col-md-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session/Week", -1)
const _hoisted_73 = { class: "col-md-1" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Remove", -1)
const _hoisted_75 = ["onClick", "disabled"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" })
], -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }),
  /*#__PURE__*/_createTextVNode(" Add new term ")
], -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "card mb-5 mb-xl-10" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Configuration")
  ])
], -1)
const _hoisted_83 = {
  id: "course_configuration",
  class: "collapse show"
}
const _hoisted_84 = { class: "collapse show" }
const _hoisted_85 = { class: "card-body border-top p-5" }
const _hoisted_86 = { "data-kt-stepper-element": "content" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-3" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enrollment Grace (day)")
], -1)
const _hoisted_90 = { class: "col-md-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Replacement Allowed")
], -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " Duration using Attendance completion % ", -1)
const _hoisted_93 = { class: "col-md-3" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dropout %")
], -1)
const _hoisted_95 = { class: "col-md-3" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Replacement %")
], -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of dropout replacement by new trainee ", -1)
const _hoisted_98 = { class: "row mt-3 p-5" }
const _hoisted_99 = { class: "col-md-4" }
const _hoisted_100 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Assessment Applicable? ", -1)
const _hoisted_102 = { class: "col-md-4" }
const _hoisted_103 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Certification Applicable? ", -1)
const _hoisted_105 = { class: "col-md-4" }
const _hoisted_106 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Employment Applicable? ", -1)
const _hoisted_108 = { class: "row mt-3" }
const _hoisted_109 = { class: "col-md-4" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Employemnt Bill Claim %")
], -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of employment required for claim. ", -1)
const _hoisted_112 = { class: "card mb-5 mb-xl-10" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_bill_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Bill Configuration")
  ])
], -1)
const _hoisted_114 = {
  id: "course_bill_configuration",
  class: "collapse show"
}
const _hoisted_115 = { class: "collapse show" }
const _hoisted_116 = { class: "card-body border-top p-5" }
const _hoisted_117 = { "data-kt-stepper-element": "content" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-md-2" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Claim", -1)
const _hoisted_122 = { class: "col-md-2" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Milestone", -1)
const _hoisted_124 = { class: "col-md-1" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim%", -1)
const _hoisted_126 = { class: "col-md-3" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advance Adjustment %", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Claim Cost")
  ])
], -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-success" }, "0.0")
  ])
], -1)
const _hoisted_130 = { class: "d-flex" }
const _hoisted_131 = ["data-kt-indicator"]
const _hoisted_132 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_133 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_134 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[32] || (_cache[32] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.entity.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_type_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(),
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      modelValue: _ctx.entity.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString("[" + info.entity_short_name + "] - " + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "parent_entity_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Contract",
                      modelValue: _ctx.entity.contract,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.contract) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "CT-01",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("CT-01")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "CT-02",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("CT-02")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "CT-03",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("CT-03")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "CT-04",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("CT-04")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "industry_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Type",
                      modelValue: _ctx.entity.contract,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entity.contract) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "UpSkill",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("UpSkill")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "industry_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Type",
                      modelValue: _ctx.entity.course_category,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entity.course_category) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      name: "course_category"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "UpSkill",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("UpSkill")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_category",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Type",
                      modelValue: _ctx.entity.course_sector,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entity.course_sector) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      name: "course_sector"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "UpSkill",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("UpSkill")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.course_unit_cost,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entity.course_unit_cost) = $event)),
                      name: "course_unit_cost",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_unit_cost",
                      class: "fv-plugins-message-container invalid-feedback"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "industry_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.entity.course,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entity.course) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Graphic Design",
                          value: "Graphic Design"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Graphic Design")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Web Application - dot net",
                          value: "Web Application - dot net"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Web Application - dot net")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Web Application - PHP",
                          value: "Web Application - PHP"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Web Application - PHP")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "industry_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_Field, {
                      name: "entity_name",
                      class: "form-control",
                      modelValue: _ctx.entity.course_code,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entity.course_code) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.course,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entity.course) = $event)),
                      name: "entity_short_name",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_short_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_Field, {
                      name: "entity_name",
                      class: "form-control",
                      modelValue: _ctx.entity.course_short_name,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entity.course_short_name) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.target_batch,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entity.target_batch) = $event)),
                      name: "registration_number",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_number",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.target_size,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entity.target_size) = $event)),
                      name: "registration_number",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_number",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.registration_authority,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.entity.registration_authority) = $event)),
                      name: "registration_authority",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_authority",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.total_target_trainee,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entity.total_target_trainee) = $event)),
                      name: "telephone",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.fax,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.entity.fax) = $event)),
                      name: "fax",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.email,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.entity.email) = $event)),
                      name: "email",
                      type: "email",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.entity.address) = $event)),
                      name: "address",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.entity.address]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entity.address) = $event)),
                      name: "address",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.entity.address]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (term, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["row", { 'pt-6': index != 0 }]),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_Field, {
                      modelValue: term.term,
                      "onUpdate:modelValue": ($event: any) => ((term.term) = $event),
                      type: "text",
                      name: 'term-' + term.term,
                      class: "form-control form-control-sm text-right",
                      disabled: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.terms[index].month,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.terms[index].month) = $event),
                      name: 'month-' + term.term,
                      class: "form-control form-control-sm",
                      placeholder: "Month"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_Field, {
                      modelValue: term.day,
                      "onUpdate:modelValue": ($event: any) => ((term.day) = $event),
                      name: "day",
                      class: "form-control form-control-sm",
                      placeholder: "Day"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createVNode(_component_Field, {
                      modelValue: term.session,
                      "onUpdate:modelValue": ($event: any) => ((term.session) = $event),
                      name: "year",
                      class: "form-control form-control-sm",
                      placeholder: "Year"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_Field, {
                      modelValue: term.hour,
                      "onUpdate:modelValue": ($event: any) => ((term.hour) = $event),
                      name: "hour",
                      class: "form-control form-control-sm",
                      placeholder: "Hour"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode(_component_el_select, {
                      modelValue: term.class_type,
                      "onUpdate:modelValue": ($event: any) => ((term.class_type) = $event),
                      class: "form-select-solid",
                      placeholder: "Select Class Type",
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Training",
                          value: "Training"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Training")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Internship",
                          value: "Internship"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Internship")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createVNode(_component_Field, {
                      modelValue: term.week,
                      "onUpdate:modelValue": ($event: any) => ((term.week) = $event),
                      name: "session",
                      class: "form-control form-control-sm",
                      placeholder: "Session/Week"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-danger",
                      onClick: ($event: any) => (_ctx.removeTerm(index)),
                      type: "button",
                      disabled: index == 0
                    }, _hoisted_77, 8, _hoisted_75)
                  ])
                ], 2))
              }), 128)),
              _hoisted_78,
              _createElementVNode("button", {
                class: "btn btn-sm btn-success mt-5",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addTerm())),
                type: "button"
              }, _hoisted_80)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.enrollment_grace,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.configuration.enrollment_grace) = $event)),
                      name: "registration_number",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_number",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.replacement_allowed,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.configuration.replacement_allowed) = $event)),
                      name: "registration_number",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _hoisted_92,
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_number",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _hoisted_94,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.dropout,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.configuration.dropout) = $event)),
                      name: "registration_authority",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_authority",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.replacement,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.configuration.replacement) = $event)),
                      name: "registration_authority",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _hoisted_97,
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_authority",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "assessment_applicable",
                        modelValue: _ctx.configuration.assessment_applicable,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.configuration.assessment_applicable) = $event)),
                        value: "0"
                      }, null, 8, ["modelValue"]),
                      _hoisted_101
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("label", _hoisted_103, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "certification_applicable",
                        modelValue: _ctx.configuration.certification_applicable,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.configuration.certification_applicable) = $event)),
                        value: "0"
                      }, null, 8, ["modelValue"]),
                      _hoisted_104
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("label", _hoisted_106, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "employment_applicable",
                        modelValue: _ctx.configuration.employment_applicable,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.configuration.employment_applicable) = $event)),
                        value: "0"
                      }, null, 8, ["modelValue"]),
                      _hoisted_107
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.employemnt_bill_claim,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.configuration.employemnt_bill_claim) = $event)),
                      name: "registration_number",
                      class: "form-control",
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _hoisted_111,
                    _createVNode(_component_ErrorMessage, {
                      name: "registration_number",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_112, [
        _hoisted_113,
        _createElementVNode("div", _hoisted_114, [
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("div", _hoisted_117, [
                _hoisted_118,
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _hoisted_121,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "config.term",
                      class: "form-control form-control-sm",
                      value: "CLAIM-1",
                      disabled: ""
                    })
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _hoisted_123,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Milestone",
                      modelValue: _ctx.configuration.training_milestone,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.configuration.training_milestone) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_124, [
                    _hoisted_125,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.claim_percentage,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.configuration.claim_percentage) = $event)),
                      type: "text",
                      name: "term",
                      class: "form-control form-control-sm",
                      value: "0"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _hoisted_127,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.configuration.advance_adjustment_percentage,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.configuration.advance_adjustment_percentage) = $event)),
                      type: "text",
                      name: "term",
                      class: "form-control form-control-sm",
                      value: "0"
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_128,
                  _hoisted_129
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_130, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-success",
              type: "submit",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.formSubmit()))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_132, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_133, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_134, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_135
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_131)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}